import React from 'react'
import { Link } from 'gatsby'
import './Rss.scss'

const Rss = props => {
  return (
    <div className="subscribe-container">
      <Link to={props.feedUrl}>
        Subscribe <i className="fa fa-rss"></i>
      </Link>
    </div>
  )
}

export default Rss
